import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path, FieldError } from 'react-hook-form';
import type { InputHTMLAttributes, ReactNode } from 'react';

interface FormCheckboxFieldProps<T extends FieldValues> extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name' | 'type'> {
  control: Control<T>;
  name: Path<T>;
  label?: ReactNode;
  description?: string;
  error?: FieldError;
  wrapperClassName?: string;
  checkboxClassName?: string;
  labelClassName?: string;
  reverse?: boolean;
}

export function FormCheckboxField<T extends FieldValues>({
  control,
  name,
  label,
  description,
  error,
  wrapperClassName = 'mb-3',
  checkboxClassName = '',
  labelClassName = '',
  reverse = false,
  ...checkboxProps
}: FormCheckboxFieldProps<T>) {
  return (
    <div className={wrapperClassName}>
      <label className={`form-check ${reverse ? 'form-check-reverse' : ''}`}>
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange, ...field } }) => (
            <input
              {...field}
              type="checkbox"
              checked={!!value}
              onChange={(e) => onChange(e.target.checked)}
              className={`form-check-input ${error ? 'is-invalid' : ''} ${checkboxClassName}`}
              {...checkboxProps}
            />
          )}
        />
        {label && <span className={`form-check-label ${labelClassName}`}>{label}</span>}
        {description && <span className="form-check-description">{description}</span>}
      </label>
      {error?.message && <div className="invalid-feedback d-block">{error.message}</div>}
    </div>
  );
}
